<template>
    <a-popover title="" v-model="visible" placement="bottomLeft" trigger="click">
        <a-tabs style="width: 720px" slot="content" :default-active-key="0">
            <a-tab-pane v-for="(item, key, index) in iconData" :key="index" :tab="key">
                <span @click="handleClickIconEvent('')" class="icon-item">
                    <i class="medcon error-color fs22 med-jinyong"></i>
                </span>
                <span :class="{ selected: it == selectIcon }" @click="handleClickIconEvent(it)" v-for="(it, idx) in item" :key="idx" class="icon-item">
                    <i class="fs22" :class="it"></i>
                </span>
            </a-tab-pane>
        </a-tabs>
        <a-button class="icon-btn">
            <i v-if="selectIcon" class="pr10" style="font-size: 24px" :class="selectIcon"></i>
            <span v-else class="color999">{{ $t('formConfig.please_select_icon' /* 请选择图标 */) }}</span>
            <a-icon style="color: #aaa" type="caret-down" />
        </a-button>
    </a-popover>
</template>

<script>
const iconData = require('@/config/icon.data.js');
export default {
    name: 'selectIcon',
    components: {},
    props: {
        value: {
            type: String
        }
    },
    data() {
        return {
            selectIcon: '',
            iconData,
            visible: false
        };
    },
    watch: {
        value: {
            handler(newVal) {
                this.selectIcon = newVal;
            },
            immediate: true
        }
    },
    methods: {
        handleClickIconEvent(icon) {
            this.selectIcon = icon;
            this.visible = false;
            this.$emit('change', icon);
        }
    },
    mounted() {}
};
</script>

<style lang="less" scoped>
.icon-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    line-height: 40px;
    padding: 0 10px 0 20px;
}
.icon-item {
    display: inline-block;
    margin: 2px;
    width: 60px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    vertical-align: top;
    height: 40px;
    border: 1px solid #efefef;
    &.selected {
        background: @theme;
        color: #fff;
        border-color: @theme;
    }
}
</style>
